// extracted by mini-css-extract-plugin
module.exports = {"title":"TextBlock_title__RLmCo","description":"TextBlock_description__zBcFh"};